import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Skeleton from '@mui/material/Skeleton'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import ConstrainedWrapper from './ConstrainedWrapper'

export default function DetailPageSkeleton() {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const maxWidth = isDesktop ? 960 : 600

  return (
    <Box role="status" aria-label="Loading">
      <ConstrainedWrapper maxWidth={maxWidth}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            px: 2,
            pt: isDesktop ? 4 : 2,
            pb: 1,
          }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Box sx={{ flex: 1 }} />
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
      </ConstrainedWrapper>

      <ConstrainedWrapper maxWidth={maxWidth}>
        <Box sx={{ pt: isDesktop ? 2 : 1, pb: 2, px: isDesktop ? 2 : 0 }}>
          <Card sx={{ mb: 2 }}>
            <Box sx={{ p: 2.5 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  mb: 1.5,
                }}
              >
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="text" width="45%" height={32} />
              </Box>
              <Box sx={{ display: 'flex', gap: 0.75, mb: 2, flexWrap: 'wrap' }}>
                <Skeleton variant="rounded" width={72} height={22} />
                <Skeleton variant="rounded" width={88} height={22} />
                <Skeleton variant="rounded" width={64} height={22} />
              </Box>
              <Skeleton variant="text" width="90%" />
              <Skeleton variant="text" width="78%" />
              <Skeleton variant="text" width="55%" />
            </Box>
          </Card>

          <Card>
            <Box sx={{ p: 2.5 }}>
              <Skeleton variant="text" width={140} height={24} sx={{ mb: 1 }} />
              {Array.from({ length: 3 }).map((_, i) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.5,
                    py: 1,
                  }}
                >
                  <Skeleton variant="circular" width={32} height={32} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="60%" />
                    <Skeleton variant="text" width="40%" />
                  </Box>
                </Box>
              ))}
            </Box>
          </Card>
        </Box>
      </ConstrainedWrapper>
    </Box>
  )
}
